<div *ngIf="cols > 1" class="d-flex flex-wrap justify-content-between align-items-center">
    <app-sample-text class="col-lg-6 col-12 p-4 pb-0" [block]="block"></app-sample-text>
    <app-sample-image class="col-lg-6 col-12 p-4" [block]="block"></app-sample-image>
</div>
<div *ngIf="cols <= 1" class="d-flex flex-column flex-wrap justify-content-between align-items-center">
    <app-sample-text class="p-4 pb-0" [block]="block"></app-sample-text>
    <app-sample-image class="p-4" [block]="block"></app-sample-image>
</div>
